import { useQuery } from 'hooks/useCustomQuery';
import { getPartnerServiceProfiles } from 'API/ServiceProfiles/getAllServiceProfiles';

const useGetPartnerServiceProfiles = ({ partnerID, enabled = true }) => {
    return useQuery({
        queryKey: ['serviceProfiles', 'partner', partnerID],
        queryFn: () => getPartnerServiceProfiles({ partnerID }),
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: enabled && !!partnerID,
        select: (res) => res.data,
    });
};

export default useGetPartnerServiceProfiles;
